import { createTheme } from '@mui/material/styles';

const tokens = {
  paper: '#FAF8FE',
  surface: '#FFFFFF',
  ink: '#170B33',
  slate: '#4B4165',
  line: '#E5E1F5',
  signal: '#6D28D9',
  signalDark: '#5B21B6',
  signalSoft: '#F5F3FF',
  gold: '#2563EB',
  goldDark: '#1D4ED8',
  goldSoft: '#EFF6FF',
};

const theme = createTheme({
  tokens,
  palette: {
    mode: 'light',
    background: { default: tokens.paper, paper: tokens.surface },
    primary: { main: tokens.signal, dark: tokens.signalDark, light: tokens.signalSoft, contrastText: '#FFFFFF' },
    secondary: { main: tokens.gold, dark: tokens.goldDark, light: tokens.goldSoft, contrastText: '#FFFFFF' },
    text: { primary: tokens.ink, secondary: tokens.slate },
    divider: tokens.line,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Inter", "Segoe UI", Roboto, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.015em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: tokens.paper, color: tokens.ink, overflowX: 'hidden' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: { styleOverrides: { root: { borderRadius: '10px', fontWeight: 600, boxShadow: 'none', '&:hover': { boxShadow: 'none' } } } },
    MuiCard: { styleOverrides: { root: { backgroundImage: 'none', border: `1px solid ${tokens.line}`, boxShadow: 'none' } } },
  },
});

export default theme;
